<script lang="ts" module>
  export type SmallGhostButtonProps = Omit<BaseBtnProps, 'children' | 'tooltip'> & {
    size?: 'small' | 'medium' | 'large' | number;
    icon: IconName;
    label: string;
    tooltip?: boolean | BaseBtnProps['tooltip'];
    // className?: string;
  };
</script>

<script lang="ts">
  import { tv } from 'tailwind-variants';

  import { BaseBtn, Icon, type BaseBtnProps, type IconName } from '@/ui/base';

  const styles = tv({
    base: 'rounded-sm bg-transparent p-1',
    variants: {
      disabled: {
        true: 'text-c-disabled',
        false: 'hocus:bg-btn-tert-H',
      },
    },
  });
  let {
    icon,
    size = 'small',
    tooltip: tooltipProp = true,
    ...props
  }: SmallGhostButtonProps = $props();
  let cn = $derived(styles({ disabled: props.disabled ?? false }));

  function getTooltip(prop: boolean | BaseBtnProps['tooltip'], label: string, size: number) {
    if (prop === true || typeof prop === 'string') {
      return {
        label: prop === true ? label : prop,
        size: size < 5 ? 'small' : 'large',
        anchor: 'bottom',
      };
    }

    return prop === false ? undefined : prop;
  }

  let iconSize = $derived(
    size === 'small' ? 4
    : size === 'medium' ? 5
    : size === 'large' ? 6
    : size,
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- it's to complicated for svelte
  let tooltip = $derived(getTooltip(tooltipProp, props.label, iconSize)) as any;
</script>

<BaseBtn {...props} {tooltip} class={cn}><Icon {icon} size={iconSize} /></BaseBtn>
